import { motion, useReducedMotion } from 'framer-motion';

const defaultVariants = {
  hidden: { opacity: 0, y: 10 },
  visible: { opacity: 1, y: 0 },
};

/**
 * Wrapper que anima children al entrar al viewport.
 * Respeta prefers-reduced-motion automáticamente.
 */
export function MotionSection({
  children,
  className = '',
  delay = 0,
  as = 'div',
  variants = defaultVariants,
  ...props
}) {
  const shouldReduce = useReducedMotion();
  const Component = motion[as] || motion.div;

  if (shouldReduce) {
    const Tag = as;
    return (
      <Tag className={className} {...props}>
        {children}
      </Tag>
    );
  }

  return (
    <Component
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: '-40px' }}
      transition={{ duration: 0.4, delay, ease: [0.16, 1, 0.3, 1] }}
      variants={variants}
      className={className}
      {...props}>
      {children}
    </Component>
  );
}

/**
 * Stagger container — children appear one by one.
 */
export function StaggerContainer({ children, className = '', stagger = 0.05, ...props }) {
  const shouldReduce = useReducedMotion();

  if (shouldReduce) {
    return (
      <div className={className} {...props}>
        {children}
      </div>
    );
  }

  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: '-40px' }}
      variants={{
        visible: { transition: { staggerChildren: stagger } },
      }}
      className={className}
      {...props}>
      {children}
    </motion.div>
  );
}

/**
 * Individual stagger child.
 */
export function StaggerItem({ children, className = '', ...props }) {
  return (
    <motion.div
      variants={{
        hidden: { opacity: 0, y: 8 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.35, ease: [0.16, 1, 0.3, 1] } },
      }}
      className={className}
      {...props}>
      {children}
    </motion.div>
  );
}
